@if (cannotLoadData) {
  <div class="h-full">
    <app-something-went-wrong
      [showPicture]="false"
      (retryEmitter)="ngOnInit()"></app-something-went-wrong>
  </div>
}

@if (isLoading) {
  <div class="h-full">
    <app-skeleton-form-drawer />
  </div>
}

@if (!isLoading && !cannotLoadData) {
  <div class="contact-dialog-layout">
    <div class="drawer-content-screen contact-dialog-main">
      <div class="drawer-content-screen__title">
        {{
          isEditMode
            ? ('detailsContact' | translate)
            : ('newContact' | translate)
        }}
      </div>

      <div class="drawer-content-screen__body">
        <form
          class="contact-dialog-form"
          [formGroup]="form"
          autocomplete="off"
          novalidate>
          <div class="contact-dialog-toolbar">
            <mat-checkbox color="primary" formControlName="type">
              {{ 'naturalPerson' | translate }}
            </mat-checkbox>
            @if (!isEditMode) {
              <button
                matTooltip="{{ 'resetAll' | translate }}"
                color="primary"
                mat-icon-button
                (click)="resetForNextContact()">
                <mat-icon>restart_alt</mat-icon>
              </button>
            }
          </div>

          <div class="contact-dialog-fields-grid">
            <mat-form-field class="min-w-0">
              <mat-label>{{ 'alias' | translate }}</mat-label>
              <input matInput formControlName="alias" />
              @if (hasError('alias', 'required')) {
                <mat-error>{{ 'fieldRequired' | translate }}</mat-error>
              }
            </mat-form-field>

            <app-field-tags-list
              class="min-w-0"
              [thisTags]="currentTags"
              (openAddTag)="openAddTag()"
              label="label"
              [isForm]="true" />

            @if (!form.value.type) {
              <mat-form-field class="contact-dialog-grid-span-2 min-w-0">
                <mat-label>{{ 'designation' | translate }}</mat-label>
                <input matInput formControlName="companyName" />
                @if (hasError('companyName', 'required')) {
                  <mat-error>{{ 'fieldRequired' | translate }}</mat-error>
                }
              </mat-form-field>
            }

            @if (form.value.type) {
              <mat-form-field class="min-w-0">
                <mat-label>{{ 'name' | translate }}</mat-label>
                <input matInput formControlName="firstName" />
                @if (hasError('firstName', 'required')) {
                  <mat-error>{{ 'fieldRequired' | translate }}</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="min-w-0">
                <mat-label>{{ 'lastName' | translate }}</mat-label>
                <input matInput formControlName="lastName" />
              </mat-form-field>
            }

            <mat-form-field class="min-w-0">
              <mat-label>{{ 'vatNumber' | translate }}</mat-label>
              <input matInput formControlName="vatNumber" />
              @if (hasError('vatNumber', 'invalidItalianVatNumber')) {
                <mat-error>{{
                  'invalidItalianVatNumber' | translate
                }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="min-w-0">
              <mat-label>{{ 'vatCountry' | translate }}</mat-label>
              <input matInput formControlName="vatCountry" />
            </mat-form-field>
            <mat-form-field class="contact-dialog-grid-span-2 min-w-0">
              <mat-label>{{ 'eoriCode' | translate }}</mat-label>
              <input matInput formControlName="eoriCode" />
            </mat-form-field>

            <mat-form-field class="min-w-0">
              <mat-label>{{ 'fiscalCode' | translate }}</mat-label>
              <input matInput formControlName="taxCode" />
              @if (hasError('taxCode', 'invalidItalianTaxCode')) {
                <mat-error>{{
                  'invalidItalianTaxCode' | translate
                }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="min-w-0">
              <mat-label>{{ 'transmissionFormat' | translate }}</mat-label>
              <input matInput formControlName="transmissionFormat" />
            </mat-form-field>

            <div
              class="contact-dialog-pec-email-row contact-dialog-grid-span-2">
              <div class="contact-dialog-pec-email-col min-w-0">
                <div class="contact-dialog-pec-email-fields">
                  @for (pecLine of pecAddresses.controls; track pecLine) {
                    <div class="contact-dialog-pec-email-line">
                      <mat-form-field
                        class="contact-dialog-pec-email-field w-full min-w-0">
                        <mat-label>{{ 'pecAddress' | translate }}</mat-label>
                        <input
                          matInput
                          [formControl]="$any(pecLine.get('email'))" />
                        @if (pecLine.get('email')?.errors) {
                          <mat-error>{{
                            getEmailErrorMessage(pecLine) | translate
                          }}</mat-error>
                        }
                      </mat-form-field>
                      <div class="contact-dialog-pec-email-actions">
                        <mat-radio-button
                          color="primary"
                          [checked]="$any(pecLine.get('isDefault')?.value)"
                          (change)="
                            onDefaultEmailChanged('pecAddresses', pecLine)
                          "
                          [matTooltip]="'default' | translate">
                        </mat-radio-button>
                        @if (pecAddresses.length > 1) {
                          <button
                            type="button"
                            mat-icon-button
                            (click)="removePecLine(pecLine)"
                            [attr.aria-label]="'delete' | translate"
                            matTooltip="{{ 'delete' | translate }}">
                            <mat-icon>remove</mat-icon>
                          </button>
                        }
                        @if (isLastPecLine(pecLine)) {
                          <button
                            type="button"
                            mat-icon-button
                            color="primary"
                            (click)="addPecAddress()"
                            [attr.aria-label]="'add' | translate"
                            matTooltip="{{ 'add' | translate }}">
                            <mat-icon>add</mat-icon>
                          </button>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div class="contact-dialog-pec-email-col min-w-0">
                <div class="contact-dialog-pec-email-fields">
                  @for (emailLine of emailAddresses.controls; track emailLine) {
                    <div class="contact-dialog-pec-email-line">
                      <mat-form-field
                        class="contact-dialog-pec-email-field w-full min-w-0">
                        <mat-label>{{ 'emailAddress' | translate }}</mat-label>
                        <input
                          matInput
                          [formControl]="$any(emailLine.get('email'))" />
                        @if (emailLine.get('email')?.errors) {
                          <mat-error>{{
                            getEmailErrorMessage(emailLine) | translate
                          }}</mat-error>
                        }
                      </mat-form-field>
                      <div class="contact-dialog-pec-email-actions">
                        <mat-radio-button
                          color="primary"
                          [checked]="$any(emailLine.get('isDefault')?.value)"
                          (change)="
                            onDefaultEmailChanged('emailAddresses', emailLine)
                          "
                          [matTooltip]="'default' | translate">
                        </mat-radio-button>
                        @if (emailAddresses.length > 1) {
                          <button
                            type="button"
                            mat-icon-button
                            (click)="removeEmailLine(emailLine)"
                            [attr.aria-label]="'delete' | translate"
                            matTooltip="{{ 'delete' | translate }}">
                            <mat-icon>remove</mat-icon>
                          </button>
                        }
                        @if (isLastEmailLine(emailLine)) {
                          <button
                            type="button"
                            mat-icon-button
                            color="primary"
                            (click)="addEmailAddress()"
                            [attr.aria-label]="'add' | translate"
                            matTooltip="{{ 'add' | translate }}">
                            <mat-icon>add</mat-icon>
                          </button>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>

            <mat-form-field class="min-w-0">
              <mat-label>{{ 'legalAddress' | translate }}</mat-label>
              <input matInput formControlName="address" />
            </mat-form-field>
            <mat-form-field class="min-w-0">
              <mat-label>{{ 'houseNumber' | translate }}</mat-label>
              <input matInput formControlName="street" />
            </mat-form-field>

            <mat-form-field class="min-w-0">
              <mat-label>{{ 'city' | translate }}</mat-label>
              <input matInput formControlName="city" />
            </mat-form-field>
            <mat-form-field class="min-w-0">
              <mat-label>{{ 'postalCode' | translate }}</mat-label>
              <input matInput formControlName="postalCode" />
            </mat-form-field>

            <mat-form-field class="min-w-0">
              <mat-label>{{ 'province' | translate }}</mat-label>
              <input matInput formControlName="region" />
            </mat-form-field>
            <mat-form-field class="min-w-0">
              <mat-label>{{ 'country' | translate }}</mat-label>
              <input matInput formControlName="country" />
            </mat-form-field>

            <mat-form-field class="min-w-0">
              <mat-label>{{ 'recipientCode' | translate }}</mat-label>
              <input matInput formControlName="recipientCode" />
            </mat-form-field>
            <mat-form-field class="min-w-0">
              <mat-label>{{ 'routingCode' | translate }}</mat-label>
              <input matInput formControlName="routingCode" />
            </mat-form-field>
          </div>
        </form>
      </div>

      <div class="contact-dialog-actions">
        @if (isEditMode) {
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="onSendEmailToContactClick()">
            <mat-icon>mail_outline</mat-icon>
            {{ 'sendEmailToContacts' | translate }}
          </button>
        }
        <button
          mat-flat-button
          color="primary"
          [disabled]="saving || savingAndNew || !canSubmit"
          (click)="submit()">
          <app-loading-button
            text="{{ 'save' | translate }}"
            [loading]="saving"></app-loading-button>
        </button>

        @if (!isEditMode) {
          <button
            mat-stroked-button
            [disabled]="saving || savingAndNew || !canSubmit"
            (click)="submit(true)">
            <app-loading-button
              text="{{ 'saveAndNew' | translate }}"
              [loading]="savingAndNew"></app-loading-button>
          </button>
        }
      </div>
    </div>

    <app-side-panel-shell
      [useMobileView]="useMobileView"
      [isOpened]="tagMenuIsOpened"
      [header]="'addLabels'"
      [hideContentOverflow]="true"
      [contentTemplate]="tagsPanelContent"
      (closePanel)="closeAddTag()" />
  </div>
}

<ng-template #tagsPanelContent>
  <app-add-tags-dialog
    [initialTags]="currentTags"
    [loadTags]="loadTags"
    [insertTag]="insertTag"
    [saveTags]="saveLocalTags"
    [isDrawer]="false"
    header="addLabels"
    label="newLabel" />
</ng-template>
